<template>
  <validation-observer ref="denyPaymentFormRef" novalidate tag="form">
    <div class="mx-4 mt-4">
      <div class="row mb-3 pt-3">
        <div class="col-12">
          <icon-view
            icon="fas fa-times-circle"
            icon-background="#d7383f"
            icon-color="#fff"
            icon-size="14px"
            title="Denegar pago"
            variant="custom-icon-view"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              id="txtCommentDenyPayment"
              v-model="comment"
              custom-error-msg="Debe completar campo."
              :error="errors[0]"
              label="Comentario:"
              :maxlength="500"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-3 mt-md-0 mt-sm-3 pb-3">
        <div
          class="col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
        >
          <action-button
            id="btnCancel"
            i="fas fa-times-circle"
            variant="outline-danger btn-cancel danger px-3 mr-2"
            @click="onCancel()"
          >
            Cancelar
          </action-button>
          <action-button
            id="btnConfirm"
            i="fas fa-save"
            variant="success px-3"
            @click="onConfirm()"
          >
            Guardar
          </action-button>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import IconView from 'icon-view';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

export default {
  name: 'DenyPayment',
  components: {
    ValidationObserver,
    ValidationProvider,
    IconView,
    CustomTextArea,
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      comment: null,
    };
  },
  methods: {
    onCancel() {
      this.$emit('on-cancel');
    },
    async onConfirm() {
      const isValid = await this.$refs.denyPaymentFormRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Todos los campos deben ser completados para completar la acción',
          'error'
        );
        return;
      }
      this.$emit('on-confirm', this.value.assistanceSummaryId, this.comment);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .custom-drop-down {
  .vs__dropdown-toggle {
    height: 38px;
  }
}
</style>
